"use client";
import { cn } from "@/lib/utils";
import { Typography } from "../ui/typography";

const TitledSection = ({
  title,
  description,
  className,
}: TitledSectionProps) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-5 items-center max-w-4xl text-center",
        className
      )}
    >
      <Typography variant="title">{title}</Typography>
      <Typography>{description}</Typography>
    </div>
  );
};
export default TitledSection;

type TitledSectionProps = {
  title: string;
  description: string;
  className?: string;
};
